import React, { useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { GlobalContext } from '../App';
import { API_URL } from '../config';
import '../styles/components/footer.css';

const Footer = () => {
  const globalConfig = useContext(GlobalContext);

  useEffect(() => {
    if (globalConfig) {
      
    }
  }, [globalConfig]);

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          {/* <Link to={globalConfig?.Footer?.[0]?.logo?.href || '/'} className="footer-logo">
            {globalConfig?.Footer?.[0]?.logo?.image?.url ? (
              <img 
                src={`${API_URL}${globalConfig.Footer[0].logo.image.url}`} 
                alt={globalConfig?.Footer?.[0]?.logo?.label || '无冬之冬'} 
                className="footer-logo-image"
                style={{ height: '32px', marginRight: '10px' }}
              />
            ) : (
              <span style={{ fontSize: '18px', fontWeight: 'bold' }}>
                {globalConfig?.Footer?.[0]?.logo?.label || '无冬之冬'}
              </span>
            )}
          </Link>
          <div className="footer-nav">
            {globalConfig?.Footer?.[0]?.navitems?.map((item, index) => (
              <Link key={index} to={item.herf || '/'}>{item.label}</Link>
            ))}
          </div>
          <div className="footer-social">
            {globalConfig?.Footer?.[0]?.sociallinks?.map((link, index) => (
              <a key={index} href={link.herf || '#'} target="_blank" rel="noopener noreferrer">
                <img 
                  src={link.image?.url ? `${API_URL}${link.image.url}` : `/placeholder-icon.png`} 
                  alt={link.label || 'Social Link'} 
                />
              </a>
            ))}
          </div> */}
          <div className="footer-copyright">
            {globalConfig?.Footer?.[0]?.copyright?.map((item, index) => (
              <span key={index} style={{ marginRight: '8px' }}>
                {item.herf ? (
                  <a href={item.herf} target={item.isExternal ? "_blank" : "_self"} rel="noopener noreferrer">
                    {item.label}
                  </a>
                ) : (
                  item.label
                )}
              </span>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;